import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { validateLengthOfStayDays, getValidateLengthOfStayDaysErrorMsg, } from './utility';
import { getLengthOfStayBasicConfig, lengthOfStayDefaultSetting } from './basic-config';
import { areEqual } from '../components/utility';

export const LengthOfStayTargetSetting = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const {
    data, setData, patchErrMsg, patchTargetsApiErrMsg, targetsApiErrMsg,
  } = props;
  const lengthOfStayDatesError = value => getValidateLengthOfStayDaysErrorMsg({ code: validateLengthOfStayDays({ value }), i18n });

  const handleAddLine = () => {
    const currentLevelSettings = [...data.currentLevelSettings, ...lengthOfStayDefaultSetting];
    props.setData({ ...data, currentLevelSettings });
  };

  const params = {
    ...getLengthOfStayBasicConfig(i18n),
    handleAddLine,
    getFieldErrorMsg: lengthOfStayDatesError,
    validateParams: { targetId: 'length-of-stay-target-wrapper', patchErrMsg, targetName: 'lengthOfStay' },
    patchTargetsApiErrMsg,
    targetsApiErrMsg,
  };

  return (
    <div id="length-of-stay-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>
  );
}, areEqual);

LengthOfStayTargetSetting.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func,
  patchTargetsApiErrMsg: PropTypes.func,
  targetsApiErrMsg: PropTypes.arrayOf(PropTypes.string),
};
LengthOfStayTargetSetting.defaultProps = {
  patchErrMsg() {},
  patchTargetsApiErrMsg() {},
  targetsApiErrMsg: [],
};
